import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";

const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Input = styled.input`
  width: 84%;
  padding: 13px 36px;
  border: 1px solid ${colors.dash};
  border-radius: 6px;
  font-size: 14px;
  caret-color: ${colors.black};
  &:focus {
    outline: none;
    border-color: #333;
  }
`;

function SearchInputBar({ placeholder = "Search", onChange, value }) {
  return (
    <SearchWrapper>
      <SearchIconWrapper>
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.3723 16.1091C17.0279 15.4535 17.548 14.6751 17.9028 13.8185C18.2576 12.9619 18.4403 12.0438 18.4403 11.1166C18.4403 10.1894 18.2576 9.27131 17.9028 8.41469C17.548 7.55808 17.0279 6.77974 16.3723 6.12411C15.7167 5.46849 14.9383 4.94842 14.0817 4.5936C13.2251 4.23878 12.307 4.05615 11.3798 4.05615C10.4526 4.05615 9.53449 4.23878 8.67788 4.5936C7.82126 4.94842 7.04292 5.46849 6.3873 6.12411C5.0632 7.44821 4.31934 9.24406 4.31934 11.1166C4.31934 12.9892 5.0632 14.785 6.3873 16.1091C7.71139 17.4332 9.50725 18.1771 11.3798 18.1771C13.2523 18.1771 15.0482 17.4332 16.3723 16.1091ZM16.3723 16.1091L20.8193 20.5561"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </SearchIconWrapper>
      <Input
        value={value}
        placeholder={placeholder}
        onChange={(e) => {
          onChange && onChange(e.target.value);
        }}
      />
    </SearchWrapper>
  );
}

export default SearchInputBar;
